import { useState } from 'react';
import styled from 'styled-components';

import { LogoPmis } from '../assets/logoPmis/logoPmis';

import { useBranding } from '../context/brandingContext';
import { BreakdownForm } from '../pages/private/stayment/breakdownOccurrenceDrawer/breakdownForm';

const LogoWrapper = styled.div`
  width: 200px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
`;

const StyledLogo = styled.img<{ loaded: boolean }>`
  position: absolute;
  max-width: 220px;
  object-fit: contain;

  opacity: ${({ loaded }) => (loaded ? 1 : 0)};

  transition: opacity 0.3s ease-in-out;
`;

export function LogoCliente(): JSX.Element {
  const { branding } = useBranding();

  const [hasError, setHasError] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const { logoUrl } = branding;

  if (!logoUrl || hasError) {
    return (
      <LogoWrapper>
        <LogoPmis />
      </LogoWrapper>
    );
  }
  return (
    <LogoWrapper>
      <StyledLogo
        src={logoUrl || '/logo-pmis.svg'}
        alt="logo"
        loaded={loaded}
        onLoad={() => setLoaded(true)}
        onError={() => {
          setHasError(true);
          setLoaded(true);
        }}
      />
    </LogoWrapper>
  );
}

// link externo - usar uma imagem que ta em assets no mesmo modelo q ta o logo pmis - ALTERAR O NOME DA LOGOO
